/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    Consent,
    ConsentFromJSON,
    ConsentToJSON,
    ConsentStatus,
    ConsentStatusFromJSON,
    ConsentStatusToJSON,
} from './';

/**
 *
 * @export
 * @interface ConsentBase
 */
export interface ConsentBase {
    /**
     *
     * @type {ConsentStatus}
     * @memberof ConsentBase
     */
    consentStatus: ConsentStatus;
    /**
     *
     * @type {Consent}
     * @memberof ConsentBase
     */
    consent: Consent;
    /**
     *
     * @type {object}
     * @memberof ConsentBase
     */
    metadata: object;
}

export function ConsentBaseFromJSON(json: any): ConsentBase {
    return ConsentBaseFromJSONTyped(json, false);
}

export function ConsentBaseFromJSONTyped(json: any, _: boolean): ConsentBase {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'consentStatus': ConsentStatusFromJSON(json['consent_status']),
        'consent': ConsentFromJSON(json['consent']),
        'metadata': json['metadata'],
    };
}

export function ConsentBaseToJSON(value?: ConsentBase | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'consent_status': ConsentStatusToJSON(value.consentStatus),
        'consent': ConsentToJSON(value.consent),
        'metadata': value.metadata,
    };
}
